import { SolutionPageTemplate } from "@/components/solutions/SolutionPageTemplate";
import { Wrench, MapPinOff, Users, Calendar, Map, ShieldCheck, BarChart3 } from "lucide-react";

const challenges = [
  {
    titleKey: "solutionPages.service.challenges.items.overlap.title",
    descriptionKey: "solutionPages.service.challenges.items.overlap.description",
    icon: MapPinOff,
  },
  {
    titleKey: "solutionPages.service.challenges.items.resources.title",
    descriptionKey: "solutionPages.service.challenges.items.resources.description",
    icon: Users,
  },
  {
    titleKey: "solutionPages.service.challenges.items.scheduling.title",
    descriptionKey: "solutionPages.service.challenges.items.scheduling.description",
    icon: Calendar,
  },
];

const solutions = [
  {
    titleKey: "solutionPages.service.solutions.items.zones.title",
    descriptionKey: "solutionPages.service.solutions.items.zones.description",
    icon: Map,
  },
  {
    titleKey: "solutionPages.service.solutions.items.address.title",
    descriptionKey: "solutionPages.service.solutions.items.address.description",
    icon: ShieldCheck,
  },
  {
    titleKey: "solutionPages.service.solutions.items.balance.title",
    descriptionKey: "solutionPages.service.solutions.items.balance.description",
    icon: BarChart3,
  },
];

const relevantProducts = [
  {
    nameKey: "solutionPages.service.products.items.atlas.name",
    descriptionKey: "solutionPages.service.products.items.atlas.description",
    href: "/tjanster/atlas",
    icon: Map,
  },
  {
    nameKey: "solutionPages.service.products.items.valid.name",
    descriptionKey: "solutionPages.service.products.items.valid.description",
    href: "/tjanster/valid",
    icon: ShieldCheck,
  },
  {
    nameKey: "solutionPages.service.products.items.adresstwatt.name",
    descriptionKey: "solutionPages.service.products.items.adresstwatt.description",
    href: "/tjanster/adresstwatt",
    icon: BarChart3,
  },
];

const heroHighlights = [
  "Definiera exakta serviceområden med postnummerprecision i Atlas",
  "Säkerställ korrekta kundadresser vid bokning med Valid",
  "Håll er serviceplattform ren med Adresstvätt",
];

const productBullets: Record<string, string[]> = {
  atlas: [
    "Bygg serviceområden med postnummerytor som byggstenar – inga överlapp",
    "Analysera arbetsbelastning baserat på kundantal och geografi",
  ],
  valid: [
    "Validera serviceadresser direkt vid bokning för att undvika bomkörningar",
    "Ge kunder korrekta adressförslag i realtid via autocomplete",
  ],
  adresstwatt: [
    "Rensa felaktiga adresser i ert kundregister regelbundet",
    "Säkerställ att serviceplattformen bygger på korrekt data",
  ],
};

const ServicePage = () => {
  return (
    <SolutionPageTemplate
      solutionKey="service"
      heroIcon={Wrench}
      challenges={challenges}
      solutions={solutions}
      relevantProducts={relevantProducts}
      heroHighlights={heroHighlights}
      challengeImpactKey="Överlappande serviceområden och felaktiga adresser kostar servicebolag i snitt 15–20% av sin operativa kapacitet i form av bomkörningar och dubbelarbete."
      productBullets={productBullets}
    />
  );
};

export default ServicePage;
